<form #vacuForm="ngForm" class="flex flex-col gap-[1.35rem] mt-[.5rem] w-full h-full justify-start align-middle sm:max-w-[50rem]">

  <form class="flex flex-col gap-[1.35rem] sm:mt-[.5rem] w-full justify-start align-middle sm:max-w-[50rem]" *ngIf="!hasBookedTermsInChange">

    <div class="flex flex-col gap-1 w-full">
      <mat-label>{{"Name of template" | translate}}</mat-label>
      <mat-form-field appearance="outline" class="flex flex-row items-center">
        <mat-icon matPrefix><i class="fa-regular fa-font text-[2rem] pr-[1rem]"></i> </mat-icon>
        <input type="text" matInput name="text" #name="ngModel" [ngModelOptions]="{standalone: true}"
        [(ngModel)]="baseShiftTemplateData.name" required />
          <mat-error *ngIf="name && name.errors">
              <span *ngIf="name.errors['required']">{{"Required Field" | translate}}</span>
              <span *ngIf="name.errors['minlength']">{{"Required minimum 3 caracters" | translate}}</span>
          </mat-error>
      </mat-form-field>

      <mat-divider class="pb-[0.5rem] sm:pb-[1rem]"></mat-divider>

      <div class="w-full flex flex-row gap-3 sm:gap-5 relative mt-[1rem] mb-[0.5rem] sm:mt-[1rem] sm:mb-[1rem]">

        <div *ngIf="!((editingMode === true && shiftTemplateId !== undefined) || shiftTemplateId !== undefined)" class="px-[0.5rem] py-[0.5rem] sm:py-[1rem] sm:px-[1rem] transition-all duration-200 ease-in-out"
         [ngClass]="{'mt-[.5rem]': workWeekConfigs.length > 1}">
          <button [disabled]="editWeekConfigs"
          class="bg-secondary shadow-sm py-[0.5rem] px-[0.25rem] sm:py-[1rem] sm:px-[0.5rem] rounded-xl flex justify-center align-middle items-center max-w-[5rem] min-w-[5rem] sm:max-w-[15rem] sm:min-w-[15rem]
          transition-all duration-200 ease-in-out"
          [ngClass]="{'opacity-30': editWeekConfigs,
                      'sm:hover:cursor-pointer sm:hover:scale-[1.005] sm:hover:shadow-md sm:active:scale-[0.985] sm:active:shadow-sm': !editWeekConfigs}"
          (click)="createEmptyWeekConfig(); $event.preventDefault()">
            <div class="flex gap-1 sm:gap-3">
              <img src="/assets/image/add.svg" class="h-9">
              <div class="uppercase text-white" *ngIf="windowDimensions.width >= windowDimensions.threshold_sm">
                {{"New week config" | translate}}
              </div>
            </div>
          </button>
        </div>

        <div class="flex flex-row gap-3 h-full overflow-x-auto sm:gap-5 py-[0.5rem] px-[0.5rem] sm:py-[1rem] sm:px-[1rem]" #overflowContainer>
          <div class="relative w-max" *ngFor="let week of workWeekConfigs; let i = index">
            <div class="relative w-max shadow-sm border-solid week_item border-[0.025rem] py-[0.5rem] px-[0.5rem] sm:py-[1rem] sm:px-[1rem] flex justify-center align-middle items-center max-w-[9rem] min-w-[9rem] sm:max-w-[15rem] sm:min-w-[15rem]
            rounded-xl select-none transition-all duration-200 ease-in-out
            sm:hover:cursor-pointer sm:hover:scale-[1.005] sm:hover:shadow-md sm:hover:bg-[#f7f7f7] sm:active:scale-[0.985] sm:active:shadow-sm sm:active:bg-white"
            [ngClass]="{'border-3 border-solid border-[#2c99b1]': i === currentWeekPosition,
              'editing_item': editWeekConfigs && (canRemoveWeeks || week.removed === true) && !((editingMode === true && shiftTemplateId !== undefined) || shiftTemplateId !== undefined),
              'select-none pointer-events-none cursor-default': !canRemoveWeeks && week.removed === false && editWeekConfigs,
              'remove_hover': week.removed === false, 'redo_hover': week.removed === true,
              'mt-[.5rem]': workWeekConfigs.length > 1,
              'border-[#f44336]/20 bg-[#ebcecc]/20 text-black/20 sm:hover:text-black/40': week.removed === true,
              'bg-white text-black': week.removed === false}"
            (click)="!editWeekConfigs ? (currentWeekPosition = i) : toggleWeekToRemove(week)">
            <div class="select-none">
              {{"Week" | translate}} {{i + 1}}
            </div>

            <div *ngIf="editWeekConfigs && (canRemoveWeeks || week.removed === true)"
            class="absolute top-[-1rem] right-[-1rem] text-white shadow-md flex flex-col justify-center align-middle items-center text-center rounded-full h-[1.75rem] w-[1.75rem] z-[100]"
            [ngClass]="{'bg-[#f44336]': week.removed === false, 'bg-[#2c99b1]': week.removed === true}"
            (click)="toggleWeekToRemove(week)">
                <p *ngIf="!week.removed" class="text-[.85rem] font-semibold select-none">{{"—"}}</p>
                <i *ngIf="week.removed" class="fa-solid fa-rotate-right text-[.85rem] text-white select-none"></i>
            </div>
          </div>
          </div>
        </div>

        <button *ngIf="workWeekConfigs.length > 1 && !((editingMode === true && shiftTemplateId !== undefined) || shiftTemplateId !== undefined)"
          (click)="toggleWeekEdit(); $event.preventDefault()"
          class="flex flex-row justify-end gap-5 absolute right-0 top-[-1.5rem]">
          <i *ngIf="!editWeekConfigs" style="font-size: 1.75rem" class="fa-regular fa-edit"></i>
          <i *ngIf="editWeekConfigs" style="font-size: 2rem" class="fa-regular fa-floppy-disk"></i>
        </button>

      </div>
    </div>

    <div class="overflow-x-clip overflow-y-auto h-full bg-white w-full rounded-xl shadow-sm border-solid border-[0.025rem] p-3 sm:p-7">
        <div *ngFor="let workWeek of workWeekConfigs; let i = index">
          <div class="flex flex-col gap-3 sm:gap-5 w-full popup-anim" *ngIf="currentWeekPosition >= 0 && workWeekConfigs.length > 0 && i === currentWeekPosition">
            <div *ngFor="let workingHourConfig of workWeek.workWeekConfigData.workDaysConfig">
              <div class="flex flex-row justify-between gap-2 sm:gap-5 w-full">
                <div class="flex flex-col justify-center self-center align-middle w-1/3 text-start">

                  <p class="text-[#373737] uppercase font-bold text-[0.75rem] xs:text-[1.05rem] sm:text-[1.35rem]">
                    {{translate("DaysOfWeekFull." + workingHourConfig.dayOfWeek?.toString())}}
                  </p>

                  <div class="flex flex-row gap-5 mt-[.5rem]">
                    <label class="relative inline-flex items-center cursor-pointer">
                      <input #toggle type="checkbox"
                      [value]="workingHourConfig.working"
                      [checked]="workingHourConfig.working"
                      (change)="workingHourConfig.working = !workingHourConfig.working;"
                      class="sr-only peer">
                      <div
                        class="w-[3rem] h-[1.65rem] bg-gray-200 peer-focus:outline-none
                        peer-focus:ring-2 peer-focus:ring-[rgba(255,255,255,0.15)] rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#2c99b1]"></div>
                    </label>

                    <p class="font-normal text-[1rem] sm:text-[1.3rem] text-red-500 select-none hover:text-gray-500"
                        (click)="workingHourConfig.working = !workingHourConfig.working;"
                        *ngIf="!workingHourConfig.working">
                      {{"day not working" | translate}}
                    </p>

                    <p class="font-normal text-[1rem] sm:text-[1.3rem] text-gray-500 select-none hover:text-red-500"
                        (click)="workingHourConfig.working = !workingHourConfig.working"
                        *ngIf="workingHourConfig.working">
                      {{"day working" | translate}}
                    </p>

                  </div>
                </div>

                <div class="flex flex-row w-2/3 justify-end self-end align-left items-end gap-5">
                  <input #fromTime type="time" [value]="workingHourConfig.fromTime | date : 'HH:mm'" step="900" [disabled]="!workingHourConfig.working"
                    class="py-[.5rem] sm:py-[1rem] px-[1rem] sm:px-[1.5rem] border-[1px] rounded-lg w-full sm:w-[15rem] text-center text-black" [ngClass]="{
                        'opacity-50 border-black/50 cursor-default pointer-events-auto select-auto': workingHourConfig.working,
                        'opacity-70 border-red-500 text-black/50 cursor-default pointer-events-none select-none': !workingHourConfig.working}"
                         (keyup.enter)="updateFromTimeAddingList(fromTime.value, workingHourConfig, fromTime)"
                         (blur)=" updateFromTimeAddingList(fromTime.value, workingHourConfig, fromTime)" >

                  <div class="w-[2.5rem] h-[1px] bg-black self-center"></div>

                  <input #toTime type="time" [value]="workingHourConfig.toTime | date : 'HH:mm'" step="900" [disabled]="!workingHourConfig.working"
                    class="py-[.5rem] sm:py-[1rem] px-[1rem] sm:px-[1.5rem] border-[1px] rounded-lg w-full sm:w-[15rem] text-center text-black" [ngClass]="{
                        'opacity-50 border-black/50 cursor-default pointer-events-auto select-auto': workingHourConfig.working,
                        'opacity-70 border-red-500 text-black/50 cursor-default pointer-events-none select-none':!workingHourConfig.working}"
                        (keyup.enter)="updateToTimeAddingList(toTime.value, workingHourConfig, toTime)"
                        (blur)="updateToTimeAddingList(toTime.value, workingHourConfig, toTime)" />
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>

    <div class="bg-[#F9DEC0] rounded-md p-3 flex flex-row justify-between align-middle items-center gap-5 text-[#D94E4E] transition-all duration-200 ease-in-out"
    >
      <div>
        <svg class="w-[22px] sm:w-[32px] h-[22px] sm:h-[32px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
          <path fill="#D94E4E" d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
        </svg>
      </div>
      <div class="text-[0.85rem] sm:text-[1.35rem] w-full" > {{"Changes global configuration when you have disabled input" | translate }} </div>
    </div>

    <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem]">
      <button (click)="closeShiftPopup(); $event.preventDefault()"
        class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] bg-[#dadada] uppercase text-[#696767] sm:hover:bg-[#c4c4c4] shadow-md sm:active:scale-[0.985] sm:active:shadow-sm">
        {{ "BACK" | translate }}
      </button>

      <button [disabled]="baseShiftTemplateData.name === undefined || baseShiftTemplateData.name.length <= 0" [ngClass]="{
        'bg-[#b98d78] sm:hover:bg-[#a57d6a] sm:active:scale-[0.985] sm:active:shadow-sm': baseShiftTemplateData.name !== undefined && baseShiftTemplateData.name.length > 0,
        'bg-[#b98d78]/20 sm:hover:bg-[#a57d6a]/20': baseShiftTemplateData.name === undefined || baseShiftTemplateData.name.length <= 0
      }" (click)="commitShiftTemplate(); $event.preventDefault()" class="w-1/2 px-5 uppercase py-[.5rem] rounded-[.25rem] text-white shadow-md sm:active:scale-[0.985] sm:active:shadow-sm">
        {{"Save changes" | translate }}
      </button>
    </div>

  </form>
</form>
